import {
  AddLessonFromLibraryContentSubpageSelectionEvent,
  LessonSelectionEventType,
} from "@modules/resource-search/resource-search-types.ts";
import LessonApi from "@apis/editor.lesson.api.ts";
import { RESOURCE_DOMAIN_PATH } from "@plugins/common/constant/resource.constant.ts";
import { FROM_LOCATION_TYPE } from "@modules/assignment/service/assignment.constant.ts";
import { useRouter } from "vue-router";
import { useGoogleDrive } from "@plugins/google/composables/google-drive.ts";
import { useResourceEdit } from "@plugins/resource/composable/resource.edit.ts";
import { useErrorHandler } from "@plugins/common/composables/error.ts";
import { noOp } from "@utils/function.utils.ts";

export const useMyDriveAddFromLibrary = () => {
  const router = useRouter();
  const { checkIfHasGoogleDriveAccess, showAppAvailabilityWarningModal } = useGoogleDrive();
  const { handleSaveLessonEditHistory } = useResourceEdit();
  const { passiveApiFailHandler } = useErrorHandler();
  const onSelect = (data: AddLessonFromLibraryContentSubpageSelectionEvent, folderUuid: string) => {
    if (
      data.type !== LessonSelectionEventType.section &&
      data.type !== LessonSelectionEventType.activity
    ) {
      return;
    }
    checkIfHasGoogleDriveAccess(
      showAppAvailabilityWarningModal,
      async () => {
        const sectionIds =
          data.type === LessonSelectionEventType.section ? data.data.sectionId : [];
        const activityIds =
          data.type === LessonSelectionEventType.activity ? data.data.activityId : [];
        const response = await LessonApi.createLessonWithSourceLesson(
          data.data.lessonUuid,
          folderUuid,
          activityIds,
          sectionIds,
        );
        if (!response || response.code !== "ok") {
          passiveApiFailHandler();
        }
        const newLessonUuid = response.data;
        router.push({
          name: "EditorCover",
          params: {
            resourceDomain: RESOURCE_DOMAIN_PATH.MY_LIBRARY,
            lessonUuid: newLessonUuid,
            mode: "edit",
            fromLocation: FROM_LOCATION_TYPE.HOME,
          },
          query: {
            isNavigateToFirstActivity: false,
            showLessonPlan: undefined,
          },
        });
        handleSaveLessonEditHistory(data.data.lessonUuid, null);
      },
      noOp,
      {
        requestData: [{ uuid: data.data.lessonUuid, status: data.data.status }],
        googleDocumentRootFolderType: "LESSON",
      },
    );
  };
  return {
    onSelect,
  };
};
